import React from "react";

export default function Developers() {
  return (
    <div className="container mx-auto p-4">
      <div className="developerParagraph text-center text-white text-2xl mb-12 font-bold">
        خدمات نرم افزاری
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-4">
        <div className="developerImage flex justify-center lg:justify-start items-center w-full lg:w-[350px] xl:w-[400] mb-12 lg:mb-0">
          <img
            src="images/developers.png"
            alt="Developer GIF"
            className="w-full h-auto rounded-lg"
          />
        </div>

        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="developerInfo border-2 p-4 rounded-lg text-center">
            <h2 className="text-xl font-bold mb-2 text-white">طراحی سایت</h2>
            <p className="text-white mt-4 sm:mt-12 text-justify">
              در کدنویسی قالب طراحی سایت حرفه ای تمامی اصول اولیه سئو سایت مطابق
              با استانداردهای روز رعایت می‌شود.
            </p>
          </div>

          <div className="developerInfo border-2 p-4 rounded-lg text-center">
            <h2 className="text-xl font-bold mb-2 text-white">هاست و سرور</h2>
            <p className="text-white mt-4 sm:mt-8 text-justify">
              با خدمات هاست و سرور ما، وب‌سایت شما با سرعت بالا و امنیت بی‌نظیر
              به کاربران عرضه می‌شود. ما با ارائه فضای ذخیره‌سازی قوی، پشتیبانی
              24/7 و امکانات پیشرفته، تضمین می‌کنیم که وب‌سایت شما همیشه در
              دسترس و بدون مشکل باشد.
            </p>
          </div>

          <div className="developerInfo border-2 p-4 rounded-lg text-center">
            <h2 className="text-xl font-bold mb-2 text-white">
              فضای کار اشتراکی
            </h2>
            <p className="text-white text-justify">
              فضای کار اشتراکی اسپاد محیطی ایده‌آل برای بهره‌وری و همکاری تیمی
              فراهم می‌کند. با امکانات مدرن و طراحی الهام‌بخش، این فضا به
              کسب‌وکارها و فریلنسرها کمک می‌کند تا با انعطاف‌پذیری بالا و
              هزینه‌ای مقرون‌به‌صرفه، پروژه‌های خود را پیش ببرند.
            </p>
          </div>

          <div className="developerInfo border-2 p-4 rounded-lg text-center">
            <h2 className="text-xl font-bold mb-2 text-white">خدمات دامنه</h2>
            <p className="text-white text-justify">
              خدمات دامنه وب‌سایت اسپاد سرور به شما امکان می‌دهد تا با انتخاب
              نام‌های دامنه منحصربه‌فرد و مدیریتی ساده، هویت آنلاین خود را
              به‌سادگی ایجاد و حفظ کنید.
            </p>
          </div>
        </div>
      </div>

      <div className="mainPageRequest text-center mt-4">
        <a
          href="https://crm.spadserver.com/contact.php"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-red-400 p-3 w-40 rounded-[30px] mt-10 request">
            ارسال درخواست
          </button>
        </a>
      </div>
    </div>
  );
}
